import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { FileText, Clock, MapPin, BookOpen, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function HeroSection() {
  return <section className="py-8 md:py-12 px-4 max-w-6xl mx-auto pt-[8px] pb-[8px]" data-id="element-136">
      <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex-1 text-center lg:text-left" data-id="element-138">
          <div className="inline-block bg-cream-dark px-4 py-1.5 rounded-full text-carbon-lighter mb-6 border border-[#E8DCC8] text-[12px] font-[800] pt-[2px] pb-[2px]" data-id="element-139">
            El sistema N°1 para familias y emprendedores de cocina en Argentina
          </div>

          <h1 className="md:text-5xl lg:text-6xl font-bold mb-6 font-[Avenir,_sans-serif] text-[32px]" data-id="element-140">
            Convertí tu cocina en dinero desde hoy… <br data-id="element-141" />
            <div className="flex justify-center my-2" data-id="element-142">
              <img src="https://cdn.magicpatterns.com/uploads/7Pjfw8UGv6prtiZgcSPzgK/Diseno_sin_titulo_(6).png" alt="Mega Pack Cocina - El pack más completo" className="w-full max-w-md md:max-w-lg object-contain" data-id="element-143" />
            </div>
            <span className="text-brand-green italic text-[32px]" data-id="element-144">
              Deja de gastar de más en comida 💸🔥
            </span>
          </h1>

          <p className="md:text-xl text-carbon-lighter mb-8 max-w-2xl mx-auto lg:mx-0 text-[14px] font-[900]" data-id="element-145">
            Recetas + Costos + Ventas listos para usar. Sin buscar. Sin
            improvisar. Sin perder fin de semana.
          </p>

          <div className="grid grid-cols-2 mb-8 max-w-lg mx-auto lg:mx-0 gap-[5px]" data-id="element-146">
            <div className="flex items-center gap-2 text-sm font-medium text-carbon" data-id="element-147">
              <FileText className="w-5 h-5 text-brand-green" data-id="element-148" /> 100% PDF
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-carbon" data-id="element-149">
              <Clock className="w-5 h-5 text-brand-green" data-id="element-150" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-carbon" data-id="element-151">
              <MapPin className="w-5 h-5 text-brand-green" data-id="element-152" /> Hecho para
              Argentina
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-carbon" data-id="element-153">
              <BookOpen className="w-5 h-5 text-brand-green" data-id="element-154" /> 6 Tomos + 3
              Bonos
            </div>
          </div>

          <CTAButton fullWidth className="max-w-md mx-auto lg:mx-0 mb-6" href="https://www.digitalbibliotec.online/cart/52075964367130:1" data-id="element-155">
            🍪 → QUIERO MI MEGAPACK AHORA
          </CTAButton>

          <div className="flex flex-wrap justify-center lg:justify-start text-sm text-carbon-lighter gap-[8px]" data-id="element-156">
            <div className="flex items-center gap-1.5" data-id="element-157">
              <ShieldCheck className="w-4 h-4" data-id="element-158" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-159">
              <Lock className="w-4 h-4" data-id="element-160" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-161">
              <CreditCard className="w-4 h-4" data-id="element-162" /> Mercado Pago
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex-1 relative" data-id="element-163">
          <div className="absolute inset-0 bg-gradient-to-tr from-brand-green/10 to-transparent rounded-3xl transform rotate-3" data-id="element-164"></div>
        </motion.div>
      </div>
    </section>;
}